export default "__VITE_ASSET__f0eP8ozq__"